module.exports = __webpack_public_path__ + "static/media/exhale.147e26e0.mp3";